export enum IdentityNumberType {
  Unknown = 0,
  Swedish = 1,
}